<template>
  <div>
    <span v-if="data.column.field ==='value'">
      <div class="d-flex justify-content-between">
        <span class="text-break">
          {{ data.row.value }}
        </span>
        <span class="ml-50">
          <b-link
            v-b-modal.configuration-modal
            class="text-secondary"
            @click="setConfigurationModel(data.row)"
          >
            <GjIcon
              name="Edit"
              class="text-primary"
            />
          </b-link>
        </span>
      </div></span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'

export default {
  components: {
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const setConfigurationModel = configurationModel => {
      const model = { ...configurationModel }
      store.commit('SET_CONFIGURATION_MODEL', model)
    }
    return { setConfigurationModel }
  },
}
</script>
